module.exports = __webpack_public_path__ + "assets/img/part2.49a0f3b4.png";